// extracted by mini-css-extract-plugin
export var footer = "_r3-5";
export var fulfillmentInput = "_r3-0";
export var shipDateInput = "_r3-1";
export var shipmentModal = "_r3-2";
export var shipmentModalContent = "_r3-3";
export var tableContainer = "_r3-4";